export const ALTERNATIVES = [
  {
    slug: "gummysearch",
    name: "GummySearch",
    tagline: "Reddit audience research plus X and LinkedIn — built for outreach.",
    summary:
      "GummySearch is great at surfacing trending Reddit topics, but stops short of helping you actually reach the people behind them.",
    why: [
      "Covers Reddit alongside X (Twitter) and LinkedIn, so one campaign reaches every place your buyers vent in public.",
      "Adds an AI Reply Agent that drafts on-brand replies and DMs for human review.",
      "Scores intent so you only spend time on the 5% of posts worth replying to.",
    ],
    feature_diff: [
      ["Audience search", "Reddit", "Reddit, X & LinkedIn"],
      ["X & LinkedIn monitoring", "—", "✓"],
      ["Intent + ICP-fit scoring", "—", "✓"],
      ["AI reply drafts in your brand voice", "—", "✓"],
      ["Human-in-the-loop approval", "—", "✓"],
      ["Demo booking automation", "—", "✓"],
    ],
    keywords:
      "GummySearch alternative, X lead generation, Twitter lead generation, LinkedIn lead generation, Reddit lead generation, GummySearch competitor, X social listening, LinkedIn social listening, Reddit social listening",
  },
  {
    slug: "devi-ai",
    name: "Devi AI",
    tagline: "Cleaner replies, transparent pipeline, fairer pricing.",
    summary:
      "Devi AI was an early mover in Reddit + Facebook lead monitoring. Collavue is the modern alternative across Reddit, X (Twitter) and LinkedIn — better intent scoring and a polished, human-reviewed reply workflow.",
    why: [
      "Built for B2B SaaS teams on X (Twitter), LinkedIn and Reddit, not Facebook group owners.",
      "Drafts replies that match your brand voice instead of templated copy.",
      "Transparent intent scoring you can audit per lead.",
    ],
    feature_diff: [
      ["X, LinkedIn & Reddit monitoring", "limited", "✓"],
      ["Brand-voice AI replies", "templated", "✓"],
      ["Intent scoring 0–100", "—", "✓"],
      ["Built-in CRM-lite inbox", "—", "✓"],
      ["Human-in-the-loop approval", "—", "✓"],
    ],
    keywords:
      "Devi AI alternative, Devi AI competitor, AI social listening, X lead generation AI, Twitter lead generation AI, LinkedIn lead generation AI, Devi alternative for SaaS",
  },
  {
    slug: "f5bot",
    name: "F5Bot",
    tagline: "F5Bot pings you. Collavue books the demo.",
    summary:
      "F5Bot is a free keyword-alert email service. Collavue takes the next step on X (Twitter), LinkedIn and Reddit: scoring intent, drafting your reply, and tracking outcomes.",
    why: [
      "No more email inbox spam — leads land in a structured inbox, not in plain-text alerts.",
      "Filters by intent, ICP fit, and recency so noise gets dropped automatically.",
      "Closes the loop with a Reply Agent that drafts and books the demo.",
    ],
    feature_diff: [
      ["Free keyword alerts", "✓", "trial available"],
      ["Platform focus", "Reddit + HN", "X, LinkedIn & Reddit"],
      ["Structured lead inbox", "—", "✓"],
      ["AI-drafted replies", "—", "✓"],
      ["Analytics & attribution", "—", "✓"],
    ],
    keywords:
      "F5Bot alternative, X keyword alerts, Twitter keyword alerts, LinkedIn keyword alerts, F5Bot competitor, social mention monitoring, lead alerts tool",
  },
  {
    slug: "subreddit-signals",
    name: "Subreddit Signals",
    tagline: "Everything a Reddit lead tool does — plus X, LinkedIn, and the reply.",
    summary:
      "Subreddit Signals is a focused Reddit lead tool. Collavue covers the same subreddits and adds X (Twitter) and LinkedIn, intent scoring, and a brand-voice reply workflow on top.",
    why: [
      "Searches Reddit threads alongside X (Twitter) and LinkedIn — your buyers complain in all three.",
      "Reply Agent drafts and queues messages for human approval.",
      "Better intent scoring that weights pain language and competitor mentions.",
    ],
    feature_diff: [
      ["Platform focus", "Reddit-only", "X, LinkedIn & Reddit"],
      ["X & LinkedIn coverage", "—", "✓"],
      ["AI reply drafting", "basic", "brand-voice"],
      ["Human approval queue", "—", "✓"],
      ["Pipeline analytics", "—", "✓"],
    ],
    keywords:
      "Subreddit Signals alternative, X lead generation tool, Twitter lead generation tool, LinkedIn lead generation tool, Reddit lead generation tool, Subreddit Signals competitor, X B2B leads",
  },
  {
    slug: "replyguy",
    name: "ReplyGuy",
    tagline: "Reply automation with a human-in-the-loop.",
    summary:
      "ReplyGuy automates replies on social. Collavue is the safer, brand-aware alternative across X (Twitter), LinkedIn and Reddit that keeps a human reviewer in the loop.",
    why: [
      "Drafts X (Twitter), LinkedIn and Reddit replies — never auto-posts without your approval.",
      "Brand voice training so your replies sound like you, not a bot.",
      "Pipeline metrics: replies sent → demos booked.",
    ],
    feature_diff: [
      ["Auto-reply on X", "auto", "human-approved"],
      ["Brand voice training", "limited", "✓"],
      ["X, LinkedIn & Reddit lead inbox", "—", "✓"],
      ["Intent scoring", "—", "✓"],
      ["Risk of platform bans", "higher", "lower"],
    ],
    keywords:
      "ReplyGuy alternative, automated X replies, automated Twitter replies, automated LinkedIn replies, AI reply tool, ReplyGuy competitor, safe AI outreach",
  },
  {
    slug: "redreach",
    name: "RedReach",
    tagline: "Public replies, not cold DMs — across X, LinkedIn and Reddit.",
    summary:
      "RedReach focuses on Reddit DMs. Collavue works the public conversation layer instead — the same subreddits plus X (Twitter) and LinkedIn — with smarter scoring and better drafts.",
    why: [
      "Your X (Twitter), LinkedIn and Reddit outreach in a single workspace.",
      "Brand-voice drafts tuned per source — a Reddit comment reads nothing like a LinkedIn post.",
      "Audit log for compliance-conscious teams.",
    ],
    feature_diff: [
      ["Platform focus", "Reddit DMs", "Public posts on X, LinkedIn & Reddit"],
      ["X, LinkedIn & Reddit outreach", "—", "✓"],
      ["AI brand-voice drafts", "basic", "✓"],
      ["Intent + risk scoring", "—", "✓"],
      ["Compliance audit log", "—", "✓"],
    ],
    keywords:
      "RedReach alternative, X outreach tool, Twitter outreach tool, LinkedIn outreach tool, Reddit outreach tool, RedReach competitor, X lead generation alternative",
  },
  {
    slug: "octolens",
    name: "OctoLens",
    tagline: "X, LinkedIn and Reddit listening with an outreach engine attached.",
    summary:
      "OctoLens is a strong listening tool for SaaS. Collavue is the alternative when you want listening across X (Twitter), LinkedIn and Reddit plus an integrated reply workflow in one tool.",
    why: [
      "Closes the gap between listening on X, LinkedIn and Reddit and actually replying to the lead.",
      "Reply Agent drafts in your brand voice instead of generic suggestions.",
      "Track which mentions actually convert to pipeline.",
    ],
    feature_diff: [
      ["X (Twitter) listening", "✓", "✓"],
      ["LinkedIn listening", "—", "✓"],
      ["Reddit listening", "—", "✓"],
      ["Mention sentiment", "✓", "✓"],
      ["AI reply drafting", "limited", "✓"],
      ["Pipeline attribution", "—", "✓"],
      ["Human approval queue", "—", "✓"],
    ],
    keywords:
      "OctoLens alternative, OctoLens competitor, X social listening, Twitter social listening for SaaS, LinkedIn social listening, AI reply social listening",
  },
  {
    slug: "syften",
    name: "Syften",
    tagline: "Modern UI across X, LinkedIn and Reddit, AI scoring, and built-in reply drafting.",
    summary:
      "Syften has been a reliable forum-monitoring tool for years. Collavue is the modern alternative — the same Reddit coverage plus X (Twitter) and LinkedIn, with AI scoring, brand-voice drafts, and a polished inbox.",
    why: [
      "AI intent scoring instead of raw keyword rules.",
      "One-click brand-voice drafts inside a single X, LinkedIn and Reddit inbox.",
      "Integrations with Slack, HubSpot, and Notion.",
    ],
    feature_diff: [
      ["Platform focus", "Forum & Reddit", "X, LinkedIn & Reddit"],
      ["X & LinkedIn coverage", "limited", "✓"],
      ["AI intent scoring", "—", "✓"],
      ["Brand-voice replies", "—", "✓"],
      ["Human approval queue", "—", "✓"],
    ],
    keywords:
      "Syften alternative, forum monitoring tool, Syften competitor, AI Syften alternative, X & Twitter lead alerts, LinkedIn lead alerts",
  },
  {
    slug: "brand24",
    name: "Brand24",
    tagline: "Built for X, LinkedIn and Reddit outreach, not just brand reporting.",
    summary:
      "Brand24 is an enterprise mention monitor. Collavue is the alternative for growth and SDR teams who want to act on mentions across X (Twitter), LinkedIn and Reddit, not just track them.",
    why: [
      "Operational: every X, LinkedIn and Reddit mention has a reply path, not just a dashboard.",
      "Lower-cost, growth-team-friendly pricing.",
      "Drafts in your brand voice for every flagged mention.",
    ],
    feature_diff: [
      ["X (Twitter) mention monitoring", "✓", "✓"],
      ["LinkedIn post monitoring", "limited", "✓"],
      ["Reddit thread monitoring", "limited", "✓"],
      ["Sentiment analysis", "✓", "✓"],
      ["AI reply drafting", "—", "✓"],
      ["Lead inbox + CRM lite", "—", "✓"],
      ["Pricing", "$$$ enterprise", "growth-friendly"],
    ],
    keywords:
      "Brand24 alternative, Brand24 competitor, X social listening alternative, Twitter mention monitoring for SaaS, LinkedIn mention monitoring",
  },
  {
    slug: "kwatch-io",
    name: "KWatch.io",
    tagline: "From keyword pings to booked demos on X, LinkedIn & Reddit.",
    summary:
      "KWatch.io alerts you when keywords appear online. Collavue is the alternative that scores those alerts across X (Twitter), LinkedIn and Reddit, drafts the reply, and tracks the outcome.",
    why: [
      "Filters out noise with AI intent scoring.",
      "Replies are drafted in your voice and queued for approval.",
      "Outcomes are tracked: replies sent, demos booked, revenue tied back.",
    ],
    feature_diff: [
      ["Keyword alerts", "✓", "✓"],
      ["Intent scoring", "—", "✓"],
      ["Reply drafting", "—", "✓"],
      ["Outcome tracking", "—", "✓"],
      ["Platform focus", "general", "X, LinkedIn & Reddit"],
    ],
    keywords:
      "KWatch.io alternative, X keyword monitoring alternative, Twitter keyword alerts, LinkedIn keyword alerts, KWatch competitor, social keyword alerts",
  },
  {
    slug: "mention",
    name: "Mention",
    tagline: "An outreach-first alternative to Mention on X, LinkedIn and Reddit.",
    summary:
      "Mention is a long-running listening platform. Collavue is the alternative built for teams whose KPI is pipeline, not share-of-voice — across X (Twitter), LinkedIn and Reddit.",
    why: [
      "Optimized for SDR, growth, and founder-led GTM on X, LinkedIn and Reddit.",
      "Reply Agent turns X, LinkedIn and Reddit mentions into outreach drafts.",
      "Fewer dashboards, more booked meetings.",
    ],
    feature_diff: [
      ["X (Twitter) mention tracking", "✓", "✓"],
      ["LinkedIn post tracking", "limited", "✓"],
      ["Reddit thread tracking", "limited", "✓"],
      ["Sentiment & analytics", "✓", "✓"],
      ["AI reply drafting", "—", "✓"],
      ["Booked-meeting tracking", "—", "✓"],
      ["Best for", "PR / brand", "growth / SDR"],
    ],
    keywords:
      "Mention alternative, mention.com competitor, X social listening for growth teams, LinkedIn social listening, AI lead outreach",
  },
  {
    slug: "redship",
    name: "RedShip",
    tagline: "Reddit leads too — plus X and LinkedIn, smarter scoring, safer replies.",
    summary:
      "RedShip ships Reddit leads. Collavue ships those same Reddit leads alongside X (Twitter) and LinkedIn, with smarter scoring and one unified reply workflow.",
    why: [
      "Covers X (Twitter), LinkedIn and Reddit — B2B buying signals show up in public threads on all three.",
      "Brand-voice replies that don't sound templated.",
      "Human-approved sending so accounts stay safe.",
    ],
    feature_diff: [
      ["Platform focus", "Reddit", "X, LinkedIn & Reddit"],
      ["X, LinkedIn & Reddit lead discovery", "—", "✓"],
      ["Brand-voice drafts", "basic", "✓"],
      ["Approval queue", "—", "✓"],
      ["Pipeline analytics", "—", "✓"],
    ],
    keywords:
      "RedShip alternative, X lead generation, Twitter lead generation, LinkedIn lead generation, Reddit lead generation, RedShip competitor, X social lead tool",
  },
  {
    slug: "tydal",
    name: "Tydal",
    tagline: "An outreach-aware alternative to Tydal on X, LinkedIn and Reddit.",
    summary:
      "Tydal helps surface relevant conversations. Collavue extends that across X (Twitter), LinkedIn and Reddit with brand-voice replies, an approval queue, and pipeline analytics.",
    why: [
      "Surfaces X, LinkedIn and Reddit conversations and drafts the reply, in one tool.",
      "Brand voice trained on your real assets — site, docs, past replies.",
      "Tracks every reply through to demo booked.",
    ],
    feature_diff: [
      ["Conversation discovery", "✓", "✓"],
      ["AI reply drafts", "limited", "✓"],
      ["X, LinkedIn & Reddit focus", "limited", "✓"],
      ["Approval queue", "—", "✓"],
      ["Pipeline metrics", "—", "✓"],
    ],
    keywords:
      "Tydal alternative, Tydal competitor, AI conversation discovery, X social lead generation tool, Twitter lead generation, LinkedIn lead generation",
  },
  {
    slug: "linkeddit",
    name: "Linkeddit",
    tagline: "X, LinkedIn and Reddit discovery with an AI reply workflow.",
    summary:
      "Linkeddit helps you find Reddit users on LinkedIn. Collavue works the posts themselves — discovery, scoring, drafting, and human-approved sending across X (Twitter), LinkedIn and Reddit.",
    why: [
      "End-to-end: discover, score, draft, approve, send on X, LinkedIn and Reddit.",
      "One inbox for all three, filterable by source, so nothing gets worked twice.",
      "Pipeline analytics tied to revenue, not just clicks.",
    ],
    feature_diff: [
      ["X, LinkedIn & Reddit coverage", "—", "✓"],
      ["AI brand-voice replies", "—", "✓"],
      ["Intent scoring 0–100", "—", "✓"],
      ["Approval queue", "—", "✓"],
      ["Demo-booked attribution", "—", "✓"],
    ],
    keywords:
      "Linkeddit alternative, Linkeddit competitor, X social outreach, Twitter social outreach, LinkedIn social outreach, Reddit social outreach, AI social lead tool",
  },
];

export function getAlternative(slug) {
  return ALTERNATIVES.find((a) => a.slug === slug);
}
